import service from './../service.js';

export default {
    add(uuid, type, score) {
        return service.post('/support/' + uuid + '/rate', {
            type: type,
            score: score,
        });
    },
}